/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Images
import storage from '../../assets/images/icons/storage.svg';
import ddos from '../../assets/images/icons/ddos.svg';
import setup from '../../assets/images/icons/setup.svg';
import review from '../../assets/images/icons/review.svg';
import billing from '../../assets/images/icons/billing.svg';
import panel from '../../assets/images/icons/panel.svg';

function Features(props) {
    const paddingClass = () => {
        switch(props.padding) {
          case 'false': return 'why-us max-w-8xl mx-auto px-5 sm:px-5 lg:px-5';
          default: return 'why-us py-28 max-w-8xl mx-auto px-5 sm:px-5 lg:px-5';
        }
    }

    return (
        <section className={paddingClass()}>
            <div className="primary-gradient px-8 sm:px-8 md:px-10 lg:px-20 rounded-xl pt-20 pb-32">
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold">Features</h1>
                </div>
                <div className="body">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-20">
                        <div>
                            <img src={storage} alt="SSD Storage" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">SSD Storage</h1>
                            <p className="text-gray-300">Our game servers utilize the latest and fastest SSD technology available.</p>
                        </div>
                        <div>
                            <img src={ddos} alt="DDoS Protection" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">DDoS Protection</h1>
                            <p className="text-gray-300">All game servers are protected from a range of DDoS attacks via global filtering PoPs.</p>
                        </div>
                        <div>
                            <img src={setup} alt="Instant Setup" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">Instant Setup</h1>
                            <p className="text-gray-300">Your game server will be setup in seconds after payment, truly rapid.</p>
                        </div>
                        <div>
                            <img src={review} alt="Highly Reviewed" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">Highly Reviewed</h1>
                            <p className="text-gray-300">We are rated 4.6/5 on trustpilot, making us one of the best hosting solutions.</p>
                        </div>
                        <div>
                            <img src={billing} alt="Simple Billing" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">Simple Billing</h1>
                            <p className="text-gray-300">We don't have any type of contracts, pay monthly, quarterly, semi-anually, or anually and always ave the option to cancel whenever you want! No risk whatsoever.</p>
                        </div>
                        <div>
                            <img src={panel} alt="Easy Management" className="mb-7 w-16 h-16" />
                            <h1 className="text-gray-100 text-xl font-semibold mb-4">Easy Management</h1>
                            <p className="text-gray-300">Our Minecraft servers run on our fully custom panel, Cyperpanel, built around making your lives easier.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Features